import { formatNumber, formatPercentage } from '@/utils/format/number';

export type PenaltyUnit = 'percentage' | 'number';

export function formatPenalty(value: number, unit: PenaltyUnit): string {
  if (unit === 'number') {
    // The penalty mapper divides backend values by 100 for percentage display.
    return formatNumber(value * 100, 0, 5);
  }
  return formatPercentage(value, 0, 5);
}
